import type { To } from 'react-router-dom';

import {
  BILLING_DESTINATION_LEGACY,
  BILLING_SETTINGS_TAB_ITEMS,
  SETTINGS_INVOICES_PATH,
  SETTINGS_PAYMENT_METHODS_PATH,
} from './constants/billing-destination-constants';
import { BILLING_SETTINGS_TAB } from './types/billing-destination-enums';
import type {
  BillingV2SplitLocationParts,
  ResolveBillingDestinationOptions,
} from './types/billing-destination-types';



const BILLING_V2_TAB_HISTORY = 'billing-history';
const BILLING_V2_TAB_PAYMENT_METHODS = 'payment-methods';
const TAB_PARAM = 'tab';



export function isBillingV2RouteEnabled(): boolean {
  return import.meta.env.VITE_APP_BILLING_V2_ENABLED === 'TRUE';
}

export function resolveBillingDestinationPath(
  _options: ResolveBillingDestinationOptions = {},
): string {
  return BILLING_DESTINATION_LEGACY;
}

export function resolveBillingV2AliasTargetPath(): string {
  return BILLING_DESTINATION_LEGACY;
}

export function resolveBillingV2SplitTarget(
  location: BillingV2SplitLocationParts = {},
): To {
  const params = new URLSearchParams(location.search ?? '');
  const tab = params.get(TAB_PARAM);
  params.delete(TAB_PARAM);

  const remainingSearch = params.toString();
  const search = remainingSearch ? `?${remainingSearch}` : '';

  if (tab === BILLING_V2_TAB_HISTORY) {
    return {
      pathname: SETTINGS_INVOICES_PATH,
      search,
      hash: location.hash ?? '',
    };
  }

  if (tab === BILLING_V2_TAB_PAYMENT_METHODS) {
    return {
      pathname: SETTINGS_PAYMENT_METHODS_PATH,
      search,
      hash: '',
    };
  }

  return {
    pathname: BILLING_DESTINATION_LEGACY,
    search,
    hash: location.hash ?? '',
  };
}




function pathMatchesBillingSettingsTab(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}

export function resolveBillingSettingsTab(pathname: string): BILLING_SETTINGS_TAB {
  const match = BILLING_SETTINGS_TAB_ITEMS.find(item =>
    pathMatchesBillingSettingsTab(pathname, item.path)
  );
  return match?.tab ?? BILLING_SETTINGS_TAB.BILLING;
}
